module.exports = __webpack_public_path__ + "img/20220624140602.c34faefc.png";